import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import GroupIcon from "@mui/icons-material/Group";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import { Collapse, IconButton, Tooltip } from "@mui/material";
import SuiAvatar from "components/SuiAvatar";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";
import Prompt from "components/UpStyled/Prompt";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import api from "services/api";
import CommentInput from "./input";

const CommentEntry = ({
  myUserObj,
  commentObj,
  subjectid,
  parentReload,
  notifyFunc,
  size = "md",
}) => {
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isReply, setIsReply] = useState(false);
  const [likeFlag, setLikeStatus] = useState(false);
  const [likeCount, setLikeCount] = useState(0);

  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const smartdate = require("smartdate");
  smartdate.init();
  let dt = smartdate.format(new Date(commentObj.timestamp));

  useEffect(() => {
    setLikeStatus(commentObj.likeusers.includes(myUserObj.owner_id));
    setLikeCount(commentObj.likeusers.length);
  }, []);

  const changeLikeFlag = () => {
    try {
      api.comment.updatelikeflag(commentObj.id, !likeFlag).then(({ data }) => {
        return data;
      });
    } catch (err) {
      toast.error(`comment updatelikeflag failed!`);
      console.log(err);
    }
    setLikeCount(likeFlag ? likeCount - 1 : likeCount + 1);
    setLikeStatus(!likeFlag);
  };

  const reloadAfterEdit = (status) => {
    setIsEdit(false);
    if (status) parentReload(true);
  };

  const reloadAfterReply = (status) => {
    setIsReply(false);
    if (status) parentReload(true);
  };

  const deleteComment = () => {
    try {
      api.comment.delete(commentObj.id).then(({ data }) => {
        parentReload(true);
        return data;
      });
    } catch (err) {
      toast.error(`comment delete failed!`);
      console.log(err);
    }
  };

  return (
    <SuiBox sx={{ mt: 0 }}>
      {isEdit && (
        <CommentInput
          userObj={myUserObj}
          subjectid={subjectid}
          parentReload={reloadAfterEdit}
          oldComment={commentObj}
          notifyFunc={notifyFunc}
          size={size}
          allowCancel={true}
        />
      )}
      {!isEdit && (
        <SuiBox
          display="flex"
          alignItems="top"
          sx={{ justifyContent: "justify-between", width: "100%" }}
        >
          <Tooltip title={commentObj.username} placement="top-start">
            {commentObj.avatar != "" ? (
              <SuiAvatar
                src={commentObj.avatar}
                alt="profile-image"
                variant="rounded"
                size="sm"
                shadow="sm"
                sx={{ mr: 1, mt: 1 }}
                bgColor="info"
              />
            ) : (
              <SuiAvatar
                alt="profile-image"
                variant="rounded"
                size="sm"
                shadow="sm"
                sx={{ mr: 1, mt: 1 }}
                bgColor="info"
              >
                <GroupIcon fontSize="medium" />
              </SuiAvatar>
            )}
          </Tooltip>
          <SuiBox sx={{ width: "100%" }}>
            <SuiBox display="flex" alignItems="center" sx={{ justifyContent: "start" }}>
              <SuiTypography
                variant={size == "md" ? "h6" : "body1"}
                sx={{ display: "block", ml: 1, color: "#4B5563" }}
              >
                {commentObj.username}
              </SuiTypography>
              <SuiTypography
                variant={size == "md" ? "body1" : "body2"}
                sx={{ display: "block", ml: 1, color: "#4B5563", height: "fit-content" }}
              >
                {dt}
              </SuiTypography>
            </SuiBox>
            <SuiTypography
              variant={size == "md" ? "body1" : "body2"}
              sx={{ display: "block", ml: 1, color: "#4B5563" }}
            >
              {commentObj.content}
            </SuiTypography>
            {!isReply && (
              <SuiBox display="flex" alignItems="center" sx={{ justifyContent: "start", ml: 1 }}>
                <Tooltip title={likeFlag ? "Unlike" : "Like"} placement="top-start">
                  {likeFlag ? (
                    <ThumbUpIcon
                      fontSize={size == "md" ? "medium" : "small"}
                      sx={{ mr: 1 }}
                      onClick={changeLikeFlag}
                    />
                  ) : (
                    <ThumbUpOffAltIcon
                      fontSize={size == "md" ? "medium" : "small"}
                      sx={{ mr: 1 }}
                      onClick={changeLikeFlag}
                    />
                  )}
                </Tooltip>
                {likeCount > 0 && (
                  <SuiTypography variant={size == "md" ? "body1" : "body2"} sx={{ mr: 1 }}>
                    {likeCount}
                  </SuiTypography>
                )}
                <SuiButton
                  sx={{ m: 0, p: 0, fontSize: size == "md" ? 14 : 12, textTransform: "none" }}
                  size="small"
                  variant="text"
                  color="info"
                  onClick={(e) => setIsReply(true)}
                >
                  Reply
                </SuiButton>
                {myUserObj.owner_id == commentObj.owner_id && (
                  <SuiButton
                    sx={{ m: 0, p: 0, fontSize: size == "md" ? 14 : 12, textTransform: "none" }}
                    size="small"
                    variant="text"
                    color="info"
                    onClick={(e) => setIsEdit(true)}
                  >
                    Edit
                  </SuiButton>
                )}
                {myUserObj.owner_id == commentObj.owner_id && (
                  <SuiButton
                    sx={{ m: 0, p: 0, fontSize: size == "md" ? 14 : 12, textTransform: "none" }}
                    size="small"
                    variant="text"
                    color="info"
                    onClick={(e) => setDeleteDialogVisible(true)}
                  >
                    Delete
                  </SuiButton>
                )}
              </SuiBox>
            )}
          </SuiBox>
          {deleteDialogVisible && (
            <Prompt
              heading="Delete Comment"
              text={`Are you sure you want to delete this comment?`}
              visible={deleteDialogVisible}
              okText="Delete"
              okColor="dark"
              handleOk={() => {
                setDeleteDialogVisible(false);
                deleteComment();
              }}
              handleClose={() => setDeleteDialogVisible(false)}
            />
          )}
        </SuiBox>
      )}
      {isReply && (
        <SuiBox sx={{ ml: 7 }}>
          <CommentInput
            userObj={myUserObj}
            subjectid={subjectid}
            parentReload={reloadAfterReply}
            parent_comment_id={
              commentObj.parent_comment_id == "" ? commentObj.id : commentObj.parent_comment_id
            }
            prefix_content={
              myUserObj.owner_id == commentObj.owner_id || commentObj.subComments
                ? ""
                : "@" + commentObj.username + ": "
            }
            notifyFunc={notifyFunc}
            size={size}
            allowCancel={true}
          />
        </SuiBox>
      )}
      {commentObj.subComments && commentObj.subComments.length > 0 && (
        <SuiBox sx={{ ml: 7 }}>
          <SuiBox display="flex" alignItems="center" sx={{ justifyContent: "start" }}>
            <IconButton
              size="small"
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label="show more"
            >
              <ExpandMoreIcon fontSize="small" />
              <SuiTypography variant="body1" sx={{ display: "block", ml: 1, color: "#4B5563" }}>
                {commentObj.subComments.length}{" "}
                {commentObj.subComments.length == 1 ? "reply" : "replies"}
              </SuiTypography>
            </IconButton>
          </SuiBox>
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            {commentObj.subComments.map((subCommentObj) => {
              return (
                <CommentEntry
                  key={subCommentObj.id}
                  myUserObj={myUserObj}
                  subjectid={subjectid}
                  commentObj={subCommentObj}
                  parentReload={parentReload}
                  size={size}
                />
              );
            })}
          </Collapse>
        </SuiBox>
      )}
    </SuiBox>
  );
};

export default CommentEntry;
